import { environment } from '@environment/environment';

export const AUTH_UPDATE_SESSION_URL = `${environment.loginHost}/api/auth/update-session`;
export const AUTH_CURRENT_USER_URL = `${environment.api2Url}/users/getSelf`;
export const GUEST_RESTRICTED_REQUEST_API_PREFIX = `${environment.api2Url}/logistic/request-guest-view/`;

// Сравниваем по pathname, чтобы query/hash не ломали auth-исключения.
export function isUpdateSessionRequestUrl(url: string): boolean {
  return hasSamePathname(url, AUTH_UPDATE_SESSION_URL);
}

// getSelf может получить cache-busting query, но это все еще bootstrap auth.
export function isCurrentUserRequestUrl(url: string): boolean {
  return hasSamePathname(url, AUTH_CURRENT_USER_URL);
}

// Эти 401 ожидаемы для анонимного пользователя и не должны показывать toast.
export function isAnonymousAuthBootstrapRequestUrl(url: string): boolean {
  return isCurrentUserRequestUrl(url) || isUpdateSessionRequestUrl(url);
}

// Гостевой restricted-view endpoint матчит по префиксу pathname, чтобы query/hash не ломали проверку.
export function isGuestRestrictedRequestApiUrl(url: string): boolean {
  return getPathname(url).startsWith(
    getPathname(GUEST_RESTRICTED_REQUEST_API_PREFIX),
  );
}

function hasSamePathname(url: string, expectedUrl: string): boolean {
  return getPathname(url) === getPathname(expectedUrl);
}

// Поддерживаем и абсолютные URL из environment, и относительные URL тестов.
function getPathname(url: string): string {
  try {
    return new URL(url, 'http://x-keeper.local').pathname;
  } catch {
    return url.split('?')[0].split('#')[0];
  }
}
